<template>
  <div class="layout-vertical-center">
    <transition name="el-fade-in" mode="out-in">
      <el-card
        style="width: 552px;">
        <template #header>{{ $t('register.title') }}</template>
        <div style="margin-bottom: 42px;">
          {{ $t('register.have_account') }}
          <router-link to="/login">
            {{ $t('register.clickhere') }}
          </router-link>
        </div>
        <el-form
          ref="refForm"
          :model="formData"
          :rules="rules"
          label-position="top">
          <el-form-item :label="$t('register.name')" prop="name">
            <el-input v-model="formData.name" />
          </el-form-item>
          <el-form-item :label="$t('register.email')" prop="email">
            <el-input v-model="formData.email" />
          </el-form-item>
          <el-form-item :label="$t('register.password')" prop="password">
            <el-input v-model="formData.password" :type="passwordInput ? 'password' : 'text'">
              <template #append>
                <div role="button" class="pointer" @click="passwordInput = !passwordInput">
                  <i :class="passwordInput ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('register.c_password')" prop="password_confirmation">
            <el-input v-model="formData.password_confirmation" :type="c_passwordInput ? 'password' : 'text'">
              <template #append>
                <div role="button" class="pointer" @click="c_passwordInput = !c_passwordInput">
                  <i :class="c_passwordInput ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="flex-container mt-6">
              <el-checkbox v-model="formData.agree" style="height: auto;" />
              <div class="ml-16">
                {{ $t('register.description1') }}
                <router-link to="/privacy-policy#1">
                  <span class="font-w-bold color-blue">{{ $t('register.term_condition') }}</span>
                </router-link>
                {{ $t('register.description2') }}
                <router-link to="/privacy-policy#1">
                  <span class="font-w-bold color-blue">{{ $t('register.privacy_policy') }}</span>
                </router-link>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <recaptcha ref="refRecaptcha" @response="handleRecaptchaResponse" />
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="loading"
              :disabled="disableSignup"
              type="primary"
              class="btn-full-block"
              @click="handleSignup">
              Signup
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </transition>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import Recaptcha from '@/components/Recaptcha'

const store = useStore()
const router = useRouter()
const loading = ref(false)
const refRecaptcha = ref(null)
const refForm = ref(null)
const formData = reactive({
  name: '',
  email: '',
  password: '',
  password_confirmation: '',
  g_recaptcha_response: ''
})
const rules = reactive({
  name: [{ required: true, trigger: 'blur' }],
  email: [{ required: true, type: 'email', trigger: 'blur' }],
  password: [{ required: true, trigger: 'blur' }],
  password_confirmation: [{ required: true, trigger: 'blur' }]
})
const passwordInput = ref(true)
const c_passwordInput = ref(true)
const disableSignup = computed(() => {
  if (
    formData.name &&
    formData.email &&
    formData.password &&
    formData.password_confirmation &&
    formData.agree &&
    formData.g_recaptcha_response
  ) {
    return false
  } else {
    return true
  }
})
const handleRecaptchaResponse = (response, type) => {
  if (type === 'success') {
    formData.g_recaptcha_response = response
  } else {
    formData.g_recaptcha_response = null
  }
}
const handleSignup = () => {
  if (!refForm.value) return
  refForm.value.validate((valid) => {
    if (valid) {
      loading.value = true
      store.dispatch('app/fetchRegister', formData).then((response) => {
        refRecaptcha.value.handleReset()
        loading.value = false
        ElMessage({
          type: 'success',
          message: response.data.message
        })
        router.push({
          path: '/verification',
          query: { email: formData.email }
        })
      }).catch((error) => {
        loading.value = false
        ElMessage({
          type: 'error',
          message: error.string
        })
      })
    } else {
      loading.value = false
      ElMessage({
        type: 'warning',
        message: 'Silakan Lengkapi data'
      })
      return false
    }
  })
}
</script>
